<div class="row mb-3">
  <ng-container *ngIf="data?.Object_EquipmentNonOp">
    <div class="data-card-body-noe">
      <div class="data-card-body-noe-content">
        <span class="data-card-body-noe-content-title">Non-Operational</span>
      </div>
    </div>
  </ng-container>
  <div class="col-lg col-lg-10">
    <table class="table table-heading-5 padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">{{ data?.Object_Main_Object }}</td>
        <td>{{ data?.Object_ServiceDescription }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="col-lg col-lg-2">
    <span class="float-lg-end">
      <a class="chart-line-icon"
         title="Travel time monitoring"
         [queryParams]="ttmURLParams"
         [routerLink]="['/spas/final-element-insight/travel-time-monitoring']"
         target="_blank">
        <img src="./assets/images/icons/chart-line-icon.svg" alt="">
        <!-- <i class="fa fa-chart-line"></i>-->
      </a>
    </span>
  </div>
</div>

<div class="clearfix"></div>

<div class="row">
  <!-- URL BADGES -->
  <ng-container *ngIf="hasUrlBadges('MO')">
    <div class="col-lg col-lg-12">
      <table class="table padding-td-15 table-borderless mt-0 mb-0 w-100">
        <tbody>
          <tr>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Object_Main_Object"
                [active]="data?.Object_Dev_Active"
                [inactive]="data?.Object_Dev_InActive"
                [inactiveCount]="data?.Object_Dev_InActive_Count"
                [type]="'DEV'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Object_Main_Object"
                [active]="data?.Object_Flt_Active"
                [inactive]="data?.Object_Flt_InActive"
                [inactiveCount]="data?.Object_Flt_InActive_Count"
                [type]="'RCA-F'"></app-rca-tag>
            </td>
            <td class="text-center width-25">&nbsp;</td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Object_Main_Object"
                [active]="data?.Object_Ovr_Active"
                [inactive]="data?.Object_Ovr_InActive"
                [inactiveCount]="data?.Object_Ovr_InActive_Count"
                [type]="'RCA-O'"></app-rca-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div class="col-lg col-lg-10">
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="font-weight-bold max-w-140"><span class="text-capitalize">{{ getEqLabel(data.Object_TypicalType) }}</span> type:</td>
        <td>{{ data.Object_Type }}</td>
      </tr>
      <tr>
        <td class="max-w-140"><span class="text-capitalize">{{ getEqLabel(data.Object_TypicalType) }}</span> size:</td>
        <td>{{ data.Object_Size }}</td>
      </tr>
      <tr>
        <td class="max-w-140"><span class="text-capitalize">{{ getEqLabel(data.Object_TypicalType) }}</span> manuf:</td>
        <td>{{ data.Object_Manuf }}</td>
      </tr>
      <tr>
        <td class="max-w-140"><span class="text-capitalize">{{ getEqLabel(data.Object_TypicalType) }}</span> model:</td>
        <td>{{ data.Object_Model }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Safe position:</td>
        <td>{{ data.Object_SafePosition }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Actuator type:</td>
        <td>{{ data.Object_Actuator_Type }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Actuator manuf:</td>
        <td>{{ data.Object_Actuator_Manuf }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Actuator model:</td>
        <td>{{ data.Object_Actuator_Model }}</td>
      </tr>
      <ng-container *ngIf="data.Object_Pilot_Valve_Manuf">
        <tr>
          <td class="max-w-140">Pilot valve manuf:</td>
          <td>{{ data.Object_Pilot_Valve_Manuf }}</td>
        </tr>
        <tr>
          <td class="max-w-140">Pilot valve model:</td>
          <td>{{ data.Object_Pilot_Valve_Model }}</td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="col-lg col-lg-2">
    <ng-container *ngIf="hasCurrentRating(data?.Object_currentRating_FE)">
      <span class="float-lg-end px-1 pe-1 mb-3" [innerHTML]="parseValue(data.Object_currentRating_FE)"></span>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="data.EqHub_TEK_no">
      <a [href]="data.EqHub_TEK_no" class="mb-3 float-lg-end doc-db-icon d-block" target="_blank">
        <img src="./assets/images/icons/doc-db_icon.svg" alt="">
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="data.Object_Sif">
      <a
        [routerLink]="['/spas/sif-manual/overview']"
        [queryParams]="getSIFParams(data.Object_Main_Object, true)"
        title="SIF"
        class="mb-3 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 d-block font-weight-bold"
        target="_blank">
        SIF
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="displayNotificationIcon(data.Object_Notifications_Status)">
      <a [ngClass]="{
        'float-lg-end fs-18 pt-0 pb-0 px-1 pe-1 d-block': true,
        'clickable': data.Object_Notifications_Status === 1,
        'clickable-light': data.Object_Notifications_Status === -1
        }" (click)="onOpenNotificationModal(data.Object_Main_Object)" title="Notifications">
        <i class="fa fa-tools"></i>
      </a>
    </ng-container>
  </div>
</div>

<hr>

<div class="row">
  <!-- URL BADGES -->
  <ng-container *ngIf="hasUrlBadges('C1')">
    <div class="col-lg col-lg-12">
      <table class="table padding-td-15 table-borderless mt-0 mb-2 w-100">
        <tbody>
        <tr>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.Component_TagName_1"
              [active]="data?.Component_Dev_Active_1"
              [inactive]="data?.Component_Dev_InActive_1"
              [inactiveCount]="data?.Component_Dev_InActive_Count_1"
              [type]="'DEV'"></app-rca-tag>
          </td>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.Component_TagName_1"
              [active]="data?.Component_Flt_Active_1"
              [inactive]="data?.Component_Flt_InActive_1"
              [inactiveCount]="data?.Component_Flt_InActive_Count_1"
              [type]="'RCA-F'"></app-rca-tag>
          </td>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.Component_TagName_1"
              [active]="data?.Component_Dmd_Active_1"
              [inactive]="data?.Component_Dmd_InActive_1"
              [inactiveCount]="data?.Component_Dmd_InActive_Count_1"
              [type]="'RCA-D'"></app-rca-tag>
          </td>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.Component_TagName_1"
              [active]="data?.Component_Ovr_Active_1"
              [inactive]="data?.Component_Ovr_InActive_1"
              [inactiveCount]="data?.Component_Ovr_InActive_Count_1"
              [type]="'RCA-O'"></app-rca-tag>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div class="col-lg col-lg-10">
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="font-weight-bold max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> 1:</td>
        <td>{{ data.Component_Type_1 }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Tagname:</td>
        <td>{{ data.Component_TagName_1 }}</td>
      </tr>
      <tr>
        <td class="max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> manuf:</td>
        <td>{{ data.Component_manuf_1 }}</td>
      </tr>
      <tr>
        <td class="max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> model:</td>
        <td>{{ data.Component_Model_1 }}</td>
      </tr>
      <tr>
        <td class="max-w-140">SD Level:</td>
        <td>
          <ng-container *ngIf="data?.Component_SdLevel_1">
            <ng-container *ngFor="let sdl of getSDLs(data.Component_SdLevel_1); let i = index">
              <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
              <ng-container *ngIf="i < getSDLs(data.Component_SdLevel_1).length - 1">, </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </tr>
<!--      <tr>-->
<!--        <td class="max-w-140">Funct. test prog.:</td>-->
<!--        <td>{{ data.Component_FunctTestProg_1 }}</td>-->
<!--      </tr>-->
      </tbody>
    </table>
  </div>
  <div class="col-lg col-lg-2">
    <ng-container *ngIf="hasCurrentRating(data?.Component_currentRating_1)">
      <span class="float-lg-end px-1 pe-1 mb-3" [innerHTML]="parseValue(data?.Component_currentRating_1)"></span>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="data.Component_EqHub_TEK_no_1">
      <a [href]="data.Component_EqHub_TEK_no_1" class="mb-3 float-lg-end doc-db-icon d-block" target="_blank">
        <img src="./assets/images/icons/doc-db_icon.svg" alt="">
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="data.Component_Sif_1">
      <a
        [routerLink]="['/spas/sif-manual/overview']"
        [queryParams]="getSIFParams(data.Component_TagName_1)"
        title="SIF"
        class="mb-3 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold d-block"
        target="_blank">
        SIF
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="displayNotificationIcon(data.Component_Notifications_Status_1)">
      <a [ngClass]="{
        'float-lg-end fs-18 pt-0 pb-0 px-1 pe-1 d-block': true,
        'clickable': data.Component_Notifications_Status_1 === 1,
        'clickable-light': data.Component_Notifications_Status_1 === -1
        }" (click)="onOpenNotificationModal(data.Component_TagName_1)" title="Notifications">
        <i class="fa fa-tools"></i>
      </a>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="data.Component_TagName_2">
  <hr>
  <div class="row">
    <!-- URL BADGES -->
    <ng-container *ngIf="hasUrlBadges('C2')">
      <div class="col-lg col-lg-12">
        <table class="table padding-td-15 table-borderless mt-0 mb-2 w-100">
          <tbody>
          <tr>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Component_TagName_2"
                [active]="data?.Component_Dev_Active_2"
                [inactive]="data?.Component_Dev_InActive_2"
                [inactiveCount]="data?.Component_Dev_InActive_Count_2"
                [type]="'DEV'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Component_TagName_2"
                [active]="data?.Component_Flt_Active_2"
                [inactive]="data?.Component_Flt_InActive_2"
                [inactiveCount]="data?.Component_Flt_InActive_Count_2"
                [type]="'RCA-F'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Component_TagName_2"
                [active]="data?.Component_Dmd_Active_2"
                [inactive]="data?.Component_Dmd_InActive_2"
                [inactiveCount]="data?.Component_Dmd_InActive_Count_2"
                [type]="'RCA-D'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.Component_TagName_2"
                [active]="data?.Component_Ovr_Active_2"
                [inactive]="data?.Component_Ovr_InActive_2"
                [inactiveCount]="data?.Component_Ovr_InActive_Count_2"
                [type]="'RCA-O'"></app-rca-tag>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div class="col-lg col-lg-10">
      <table class="table padding-td-15 table-borderless mb-0">
        <tbody>
        <tr>
          <td class="font-weight-bold max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> 2:</td>
          <td>{{ data.Component_Type_2 }}</td>
        </tr>
        <tr>
          <td class="max-w-140">Tagname:</td>
          <td>{{ data.Component_TagName_2 }}</td>
        </tr>
        <tr>
          <td class="max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> manuf:</td>
          <td>{{ data.Component_manuf_2 }}</td>
        </tr>
        <tr>
          <td class="max-w-140"><span class="text-capitalize">{{ getFuncLabel(data.Object_TypicalType) }}</span> model:</td>
          <td>{{ data.Component_Model_2 }}</td>
        </tr>
        <tr>
          <td class="max-w-140">SD Level:</td>
          <td>
            <ng-container *ngIf="data?.Component_SdLevel_2">
              <ng-container *ngFor="let sdl of getSDLs(data.Component_SdLevel_2); let i = index">
                <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
                <ng-container *ngIf="i < getSDLs(data.Component_SdLevel_2).length - 1">, </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </tr>
<!--        <tr>-->
<!--          <td class="max-w-140">Funct. test prog.:</td>-->
<!--          <td>{{ data.Component_FunctTestProg_2 }}</td>-->
<!--        </tr>-->
        </tbody>
      </table>
    </div>
    <div class="col-lg col-lg-2">
      <ng-container *ngIf="hasCurrentRating(data?.Component_currentRating_2)">
        <span class="float-lg-end px-1 pe-1 mb-3" [innerHTML]="parseValue(data?.Component_currentRating_2)"></span>
        <div class="clearfix"></div>
      </ng-container>

      <ng-container *ngIf="data.Component_EqHub_TEK_no_2">
        <a [href]="data.Component_EqHub_TEK_no_2" class="mb-3 float-lg-end doc-db-icon d-block" target="_blank">
          <img src="./assets/images/icons/doc-db_icon.svg" alt="">
        </a>
        <div class="clearfix"></div>
      </ng-container>

      <ng-container *ngIf="data.Component_Sif_2">
        <a
          [routerLink]="['/spas/sif-manual/overview']"
          [queryParams]="getSIFParams(data.Component_TagName_2)"
          title="SIF"
          class="mb-3 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold d-block"
          target="_blank">
          SIF
        </a>
        <div class="clearfix"></div>
      </ng-container>

      <ng-container *ngIf="displayNotificationIcon(data.Component_Notifications_Status_2)">
        <a [ngClass]="{
        'float-lg-end fs-18 pt-0 pb-0 px-1 pe-1': true,
        'clickable': data.Component_Notifications_Status_2 === 1,
        'clickable-light': data.Component_Notifications_Status_2 === -1
        }" (click)="onOpenNotificationModal(data.Component_TagName_2)" title="Notifications">
          <i class="fa fa-tools"></i>
        </a>
      </ng-container>
    </div>
  </div>
</ng-container>
<hr>
<div class="row">
  <div class="col-lg col-lg-10">
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="font-weight-bold max-w-140">Traveltime limit:</td>
        <td></td>
      </tr>
      <tr *ngIf="data?.TravelTimeLimit_Critical_Safe_State">
        <td class="max-w-140">Critical Safe State:</td>
        <td>{{ data.TravelTimeLimit_Critical_Safe_State }} s</td>
      </tr>
      <tr *ngIf="data?.TravelTimeLimit_Warning_Slow_SS">
        <td class="max-w-140">Warning slow SS:</td>
        <td>{{ data.TravelTimeLimit_Warning_Slow_SS }} s</td>
      </tr>
      <tr *ngIf="data?.TravelTimeLimit_Warning_Fast_SS">
        <td class="max-w-140">Warning fast SS:</td>
        <td>{{ data.TravelTimeLimit_Warning_Fast_SS }} s</td>
      </tr>
      <tr *ngIf="data?.TravelTimeLimit_Warning_Slow_NS">
        <td class="max-w-140">Warning slow NS:</td>
        <td>{{ data.TravelTimeLimit_Warning_Slow_NS }} s</td>
      </tr>
      <tr *ngIf="data?.TravelTimeLimit_Warning_Fast_NS">
        <td class="max-w-140">Warning fast NS:</td>
        <td>{{ data.TravelTimeLimit_Warning_Fast_NS }} s</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="col-lg col-lg-2"></div>
</div>
